// extracted by mini-css-extract-plugin
export default {"input_wrapper":"style_input_wrapper__sAc4s","label":"style_label__f0woi","customInput":"style_customInput__+uPsP"};